import { useTranslation } from 'react-i18next'
import { H3, Text, Button } from '@/components/atoms'
import { IdCard } from '@/components/molecules'
import { formatDate } from '@/shared/helpers/format-date'
import { useUser } from '@/shared/hooks/use-user'
import { petDefaultIdCardImage } from '@/shared/assets'
import type { Pet, Policy } from '@/shared/types/global.types'

export function PetStepOnePage({
  onContinue,
  pet,
  policy,
  isLoading = false,
}: {
  onContinue: () => void
  pet?: Pet
  policy?: Policy
  isLoading?: boolean
}) {
  const { t } = useTranslation()
  const { user } = useUser()

  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto pb-4 md:flex md:flex-row md:justify-between md:pb-0">
        <div className="flex flex-col justify-between gap-4 md:max-w-98 md:pt-6">
          <div className="flex flex-col gap-4 md:max-w-90 md:gap-6">
            <H3>{t('onboarding.pet.step1.title')}</H3>
            <Text className="text-neutral-600">
              {t('onboarding.pet.step1.body')}
            </Text>
          </div>
          <div className="hidden gap-3 md:mb-2.5 md:flex">
            <Button
              className="h-12"
              onClick={onContinue}
              data-testid="step-one-continue"
            >
              {t('onboarding.pet.continue')}
            </Button>
          </div>
        </div>
        <div className="hidden w-full max-w-[45%] items-center justify-end pb-10 md:flex">
          <IdCard
            variant="with-photo"
            planName={pet?.name ?? ''}
            ownerName={user?.fullName ?? ''}
            policyId={
              policy?.policyExternalId ? `#${policy.policyExternalId}` : ''
            }
            startDate={formatDate(policy?.startDate)}
            photoUrl={
              isLoading
                ? undefined
                : pet?.petPictureUrl
                  ? pet?.petPictureUrl
                  : petDefaultIdCardImage
            }
            isLoading={isLoading}
            isMobile={false}
            hidePhotoBackground={!isLoading && !pet?.petPictureUrl}
          />
        </div>
      </div>
      <div className="flex w-full gap-3 pt-4 md:hidden">
        <Button
          className="h-12 w-full"
          onClick={onContinue}
          data-testid="step-one-continue"
        >
          {t('onboarding.pet.continue')}
        </Button>
      </div>
    </div>
  )
}
